import React from 'react';

const DRAFT_CELL_BASE = 'px-3 py-3';
const DRAFT_CELL_BASE_COMPACT = 'px-2 py-1.5';

/**
 * Row cell alignment: middle when clean, top when any column shows a validation hint
 * so controls stay aligned and hints sit below.
 */
export function draftRowCellTdClass(rowHasVisibleErrors: boolean, compact = false): string {
  const base = compact ? DRAFT_CELL_BASE_COMPACT : DRAFT_CELL_BASE;
  return `${base} ${rowHasVisibleErrors ? 'align-top' : 'align-middle'}`;
}

type DraftFieldCellProps = {
  shellClassName: string;
  hint: string | null;
  hintClassName?: string;
  hintMarginClass?: string;
  children: React.ReactNode;
};

/**
 * Column shell: fixed-width control on top, validation message below.
 * Row height grows with the tallest hint; controls stay top-aligned across columns.
 */
export function DraftFieldCell({
  shellClassName,
  hint,
  hintClassName,
  hintMarginClass = 'mt-1',
  children,
}: DraftFieldCellProps): React.ReactElement {
  return (
    <div className={`flex flex-col ${shellClassName}`}>
      <div className="shrink-0">{children}</div>
      {hint ? (
        <div className={`${hintMarginClass} w-full`} aria-live="polite">
          <p
            className={`break-words text-[11px] font-normal leading-snug text-red-600 ${hintClassName ?? ''}`}
          >
            {hint}
          </p>
        </div>
      ) : null}
    </div>
  );
}
